var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2012 37.5292H50.1781L39.1306 20.0262C39.1081 19.9907 39.056 19.9916 39.0347 20.028L29.0278 37.2295C28.9504 37.3627 29.0467 37.5292 29.2012 37.5292Z",
    fill: "#D0E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7303 36.124V72.6157C35.7292 74.0505 37.498 63.8171 39.1032 65.5669C40.8848 63.8387 42.7249 59.6278 44.9002 58.2603V36.124H33.7303Z",
    fill: "#D0E7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3381 37.5136C71.3269 37.3767 71.2114 37.2708 71.0733 37.2717C55.058 37.3855 41.3645 46.4811 35.4264 60.9524C35.4264 60.9524 35.4264 60.9527 35.4264 60.953C35.4209 60.9658 35.4154 60.9782 35.4099 60.9909H35.4172C32.3336 67.8616 34.1064 79.4167 34.3974 91.3305C34.405 91.6433 34.6609 91.893 34.9751 91.893H46.3175C46.4686 91.893 46.589 91.7665 46.581 91.616C46.0667 81.7655 45.4744 73.1025 46.8236 64.9157C47.2331 62.4301 48.2968 60.0931 49.9118 58.1546C55.0245 52.0167 62.7408 48.1065 71.3741 48.1065C71.5575 48.1065 71.7403 48.1059 71.9226 48.1078C72.0777 48.1093 72.2008 47.9779 72.188 47.8238L71.3384 37.5136H71.3381Z",
    fill: "#0071E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7157 32.5581L67.3282 53.7319L84.0941 41.3843L65.7157 32.5581Z",
    fill: "#0071E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.50ad2398be612bec6d23f0c291f405a5.svg";
export { ForwardRef as ReactComponent };